import { useAreaData } from '../../hooks/useAreaData.js';
import type { AreaSeriesWithDatapoints } from '../../types/xy-chart-internals.js';
import type { AreaDatapoint } from '../../types/xy-chart.js';
import { ClosestPointTooltip } from './ClosestPointTooltip/ClosestPointTooltip.js';

export function AreaSeriesTooltip({
  datapoint,
  series,
}: Readonly<{
  datapoint: AreaDatapoint;
  series: AreaSeriesWithDatapoints;
}>) {
  const { seriesToMetadata } = useAreaData();

  return (
    <ClosestPointTooltip
      datapoint={datapoint}
      series={series}
      seriesToMetadata={seriesToMetadata}
    />
  );
}
